import React from "react"
import styled from 'styled-components'
import HeroMenu from "./heroMenu"
import LangSwitcherStrip from "./LangSwitcherStrip"
import { useTranslation } from 'react-i18next'
import Breadcrumb from "./BreadcrumbNavigation"
import { Link } from "gatsby"
import BackgroundImage from "./BackgroundImage3"
const HeroSection = ({title, text, custombuttonText, customlink}) => {
  const { t } = useTranslation()
  const navigateLink = customlink ? customlink : t('urls.register')
  const buttonText = custombuttonText ? custombuttonText : t('root.getStarted')
  
  return (
    <>
      <HeroMenu/>
      <LangSwitcherStrip/>
      <HeaderWrapper> 
        <HeaderContent>
          <Breadcrumb/>
          <HeaderTitle >{title}</HeaderTitle>
          {text && <HeaderText dangerouslySetInnerHTML={{ __html: text}}/>}
          <ButtonCenterWrapper >
            <Button to={navigateLink}>{buttonText}</Button>
          </ButtonCenterWrapper>
        </HeaderContent>
        <HeaderGradient/>
  {/* {      <ImageWrapper><img loading="eager" src={keyartwork } alt="flaoting women with headphones"/></ImageWrapper>} */}
        <ImageWrapper>
          <BackgroundImage/>
        </ImageWrapper>
      </HeaderWrapper> 
    </>
  )
}


export default HeroSection



const SwitchBreakpoint = "1200px"
const height = "450px"

const HeaderTitle = styled.h1`
  font-size: 3rem;
  color: #2C2C2C;
  ${props => props.center ? 'text-align:center;' : ''}
  @media (max-width: ${SwitchBreakpoint}) {
    margin-top: 40px;
    font-size: 2rem;
    text-align:center;
  }
`

const HeaderText = styled.p`
  font-family:${props => props.theme.mainFontParagraph},'Arial';
  font-size: 18px;
  color: #4B4B4B;
  @media (max-width: ${SwitchBreakpoint}) {
    text-align:center;
  }
`

const ButtonCenterWrapper = styled.div`
  width: 100%;
  display:flex;
  align-items:center;
  justify-content:center;
  @media(min-width: ${SwitchBreakpoint})  {
    display:block;
    width:auto;
  }
`

const HeaderWrapper = styled.div`
  height:auto;
  z-index: 20;
  box-sizing:border-box;
  display:flex;
  background-color:#fcd3cc;
  position:relative;
  justify-content:center;
  @media (min-width: ${SwitchBreakpoint}) {
    padding: 50px;
  } 
`

const HeaderContent = styled.div`
  width: 45%;
  max-width: 600px;
  z-index: 99;
  margin-bottom: 20px;
  min-height: ${height};
  @media (max-width:${SwitchBreakpoint}) {
    margin:0px auto 0px auto;
    width: 90%;
  }
`

const HeaderGradient = styled.div`
  position: absolute;
  z-index: 10;
  bottom:0px;
  width: 100%;
  background: -webkit-linear-gradient(top, rgba(255, 255, 255, 0), rgb(255, 255, 255));
  height: 130px;
  pointer-events: none;
`

const ImageWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 33%;
  display:flex;
  justify-content:center;
  align-items:center;
  @media (max-width:${SwitchBreakpoint}) {
    display: none;
    position: absolute;
    width: 70%;
    opacity: 0.5;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  >img {
    height: 400px;
    width:305px;
  }
`


const Button = styled(Link)`
  font-family: 'Poppins';
  text-decoration: none;
  padding: 10px 15px;
  background:#F19D9A;
  position:relative;
  z-index:20;
  color:white;
  border-radius:25px;
  cursor:pointer;
  text-transform: uppercase;
  white-space:nowrap;
  &:hover{
    color:white;
    background:#D98179;
  }
  font-size:1rem;
  height: 45px;
  box-shadow: 0 2px 6px 0 hsla(0, 0%, 0%, 0.2);
`